import { render, staticRenderFns } from "./CommunityServiceProviders.vue?vue&type=template&id=61b1337a&"
import script from "./CommunityServiceProviders.vue?vue&type=script&lang=ts&"
export * from "./CommunityServiceProviders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports